module.exports = __webpack_public_path__ + "static/img/img54.4e8e78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img54.png
// module id = ubPf
// module chunks = 1